import { leadService } from 'services';
import {browserHistory} from 'react-router';
import shortid from 'shortid';

export const FETCH_LEADS_BEGIN = 'leads/FETCH_LEADS_BEGIN';
export const FETCH_LEADS_SUCCESS = 'leads/FETCH_LEADS_SUCCESS';
export const FETCH_LEADS_ERROR = 'leads/FETCH_LEADS_ERROR';


export const FETCH_PUBLIC_LEADS_BEGIN = 'leads/FETCH_PUBLIC_LEADS_BEGIN';
export const FETCH_PUBLIC_LEADS_SUCCESS = 'leads/FETCH_PUBLIC_LEADS_SUCCESS';
export const FETCH_PUBLIC_LEADS_ERROR = 'leads/FETCH_PUBLIC_LEADS_ERROR';

export const CREATE_LEAD_BEGIN = 'leads/CREATE_LEAD_BEGIN';
export const CREATE_LEAD_SUCCESS = 'leads/CREATE_LEAD_SUCCESS';
export const CREATE_LEAD_ERROR = 'leads/CREATE_LEAD_ERROR';

export const CREATE_REFERRAL_BEGIN = 'leads/CREATE_REFERRAL_BEGIN';
export const CREATE_REFERRAL_SUCCESS = 'leads/CREATE_REFERRAL_SUCCESS';
export const CREATE_REFERRAL_ERROR = 'leads/CREATE_REFERRAL_ERROR';

export const SHARE_SUCCESS = 'leads/SHARE_SUCCESS'
export const SHARE_ERROR = 'leads/SHARE_ERROR'

export const CLICK_SUCCESS = 'leads/CLICK_SUCCESS'
export const CLICK_ERROR = 'leads/CLICK_ERROR'

export const VISIT_SUCCESS = 'leads/VISIT_SUCCESS'
export const VISIT_ERROR = 'leads/VISIT_ERROR'

export function fetchLeadsBegin(){
    return {
        type: FETCH_LEADS_BEGIN
    }
}

export function fetchLeadsSuccess(data){
 return { type: FETCH_LEADS_SUCCESS, data: data };
}

export function fetchLeadsError(error){
 return { type: FETCH_LEADS_ERROR, error: error };
}

export function fetchLeads(){
    return (dispatch) => {
        dispatch(fetchLeadsBegin());
        leadService().getLeads().then((res)=>{
           return dispatch(fetchLeadsSuccess(res.data));
        }).catch((error)=> {
            return dispatch(fetchLeadsError('Failed to fetch customer list. Please try again later.'));
        });
    }
}

export function fetchPublicLeadsBegin(){
    return {
        type: FETCH_PUBLIC_LEADS_BEGIN
    }
}


export function fetchPublicLeadsSuccess(data){
    return {
        type: FETCH_PUBLIC_LEADS_SUCCESS, 
        data: data
    }
}

export function fetchPublicLeadsError(error){
    return {
        type: FETCH_PUBLIC_LEADS_ERROR,
        error
    }
}

export function fetchPublicLeads(filter){
    return (dispatch) => {
        dispatch(fetchPublicLeadsBegin());
        leadService().stats(filter).then((res)=>{
           return dispatch(fetchPublicLeadsSuccess(res.data));
        }).catch((error)=> {
            return dispatch(fetchPublicLeadsError('Failed to fetch public customer list. Please try again later.'));
        });
    }    
}

export function createLeadBegin(data){
    return {
        type: CREATE_LEAD_BEGIN,
        lead: data
    }
}

export function createLeadSuccess(discountCode){
    return {
        type: CREATE_LEAD_SUCCESS,
        discountCode: discountCode
    }
}


export function createLeadError(error){
 return { type: CREATE_LEAD_ERROR, error: error };
}

export function deleteLead(lead){
    return (dispatch)=>{
        leadService().deleteLead(lead.id).then((res)=>{
            dispatch(fetchLeads(lead.campaignId));
        }).catch(()=>{
            dispatch(fetchLeads(lead.campaignId));
        });
    }
}

export function createLead(campaignId, lead){
  let id = shortid.generate();
  
  let data = {
    ...lead,
    campaignId,
    id: id
  };

  return (dispatch) => {
     dispatch(createLeadBegin(data));
     leadService().createLead(data).then((res) => {
        dispatch(createLeadSuccess(res.data));
     }).catch(() => {
       return dispatch(createLeadError('Cannot create customer. Please try again later.'));
     });
  }
}

export function createReferralBegin(){
    return {
        type: CREATE_REFERRAL_BEGIN
    }
}
export function createReferralSuccess(){
    return {
        type: CREATE_REFERRAL_SUCCESS
    }
}

export function createReferralError(error){
    return {
        type: CREATE_REFERRAL_ERROR,
        error: error
    }
}

export function shareSuccess(){
    return {
        type: SHARE_SUCCESS
    }
}
export function shareError(){
    return {
        type: SHARE_SUCCESS
    }
}

export function clickSuccess(){
    return {
        type: CLICK_SUCCESS
    }
}
export function clickError(){
    return {
        type: CLICK_SUCCESS
    }
}

export function visitSuccess(){
    return {
        type: VISIT_SUCCESS
    }
}
export function visitError(){
    return {
        type: VISIT_SUCCESS
    }
}

export function share(campaignId){
    return (dispatch)=>{
        leadService().share(campaignId).then(()=>{
            dispatch(shareSuccess());
        }).catch(()=>{
            dispatch(shareError());
        });
    }
}

export function click(campaignId){
    return (dispatch)=>{
        leadService().click(campaignId).then(()=>{
            dispatch(clickSuccess());
        }).catch(()=>{
            dispatch(clickError());
        });
    }
}

export function visit(campaignId){
    return (dispatch)=>{
        leadService().visit(campaignId).then(()=>{
            dispatch(visitSuccess());
        }).catch(()=>{
            dispatch(visitError());
        });
    }
}

export function createReferral(refid, src){
    return (dispatch)=>{
        dispatch(createReferralBegin());
        leadService().createReferral({
            refid,
            src
        }).then((res)=>{
            dispatch(createReferralSuccess());
        }).catch(()=>{
            return dispatch(createReferralError('Cannot create referance for this lead.'));
        });
    }
}

const reducer = (state = {
    fetching: false,
    list: [],
    board:[],
    single: null
}, action = {}) => {
  
  switch (action.type) {
   
    case FETCH_LEADS_BEGIN:
      return {
          ...state,
          fetching: true,
          isSaving: false,
          list:[]
      };
    case FETCH_LEADS_SUCCESS:

        return {
            ...state,
            fetching: false,
            list: [...action.data]
        };
    case FETCH_LEADS_ERROR:
        return {
            ...state,
            fetching: false,
            isSaving: false,
            list: []
        };

    case FETCH_PUBLIC_LEADS_BEGIN:
      return {
          ...state,
          board:[]
      };
    case FETCH_PUBLIC_LEADS_SUCCESS:

        return {
            ...state,
            board: [...action.data]
        };
    case FETCH_PUBLIC_LEADS_ERROR:
        return {
            ...state,
            board: []
    }; 
        
    case CREATE_LEAD_BEGIN:
        return {
            ...state,
            fetching: true,
            isSaving: true,
            list: [...state.list].concat([action.lead]),
            discountCode:null
        };
    
    case CREATE_LEAD_SUCCESS:
    return {
        ...state,
        discountCode: action.discountCode
    }

    case CREATE_LEAD_ERROR:
    return {
        ...state,
        discountCode: ':( Bad luck! Maybe next time.'
    }

    default:
      return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// app/modules/leads.js